import React from "react"
import { Container } from "reactstrap"
import { Trans } from "@lingui/react"
import Courses from "./courses"
import { getTranslationsById, getLearningLanguage } from "./helpers"
import { connect } from "react-redux"
import { setCategoryItems } from "../../store/actions/learning"
import PropTypes from "prop-types"
import { setSelectedLanguage } from "../../store/actions/learning"
import { useLingui } from "@lingui/react"

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  margin: "4px 2.4px",
}

const MainView = (props) => {
  const { i18n } = useLingui()
  const [categories, setCategories] = React.useState([])
  setSelectedLanguage([i18n.locale])
  React.useEffect(() => {
    setSelectedLanguage([i18n.locale])
  }, [i18n.locale])

  React.useEffect(() => {
    if (!props.learningData) {
      return
    }
    // Filter out none financial literacy courses
    const filteredCategories = (props.learningData.categories || []).filter(
      (item) => item.category_id === 2,
    )
    const categoriesTrans = getTranslationsById(
      filteredCategories,
      props.learningData.translations,
      [getLearningLanguage(i18n.locale)],
    )
    setCategories(categoriesTrans)
  }, [props.learningData])

  return (
    <Container>
      <div style={containerStyle}>
        <h5>
          <Trans id="learningContent.title">Learning</Trans>
        </h5>
        <h6>
          <Trans id="learningContent.description">
            Here you can find learning materials that can help farmers develop their
            skills and increase their farming knowledge.
          </Trans>
        </h6>
        <Courses categories={categories} />
      </div>
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    learningData: state.learningData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setCategoryItems: (data) => dispatch(setCategoryItems(data)),
  }
}

MainView.propTypes = {
  learningData: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(MainView)
